import { prop } from "../../decorators/property";
import { AppSettings } from "../../app-settings";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { PublishingGroup } from "./publishing-group";

@backboneModelProperties({
    relations: [{
        type: Backbone.One,
        key: "Group",
        relatedModel: PublishingGroup
    }]
})
export class PublisherModel extends Backbone.AssociatedModel {

    @prop() public Name: string;
    @prop() public Id: string;
    @prop() public Logo: string;
    @prop() public Group: PublishingGroup;
    @prop() public DisplayLink: boolean;
    @prop() public Citations: Backbone.Model[];

    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/publisher.ts